import React from 'react';
import cn from 'classnames';

var styles = {"icon":"button__icon_aq3k5"};
 require('./buttonicon.css')

function ButtonIcon(_a) {
    var children = _a.children, className = _a.className, side = _a.side;
    var iconSideClassName = "icon_" + side;
    var classNames = cn(styles.icon, className, styles[iconSideClassName]);
    return React.createElement("span", { className: classNames }, children);
}

export { ButtonIcon as default };
